/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  cella: {
    endpoints: {
      authenticate: 'api/authenticate',
      user: 'api/users'
    },
    version: '1.0.0',
    appName: 'Cella inTrasit'
  },
  gatewayBase: 'https://gatewayqa.cella.co.za',
  cellaTrack:'https://lliner-cellatrackqa.cella.co.za',
  production: false,
  tenant: 'Luxliner',
  tenantCode: 'LLINER',
  routingApiUrl: 'https://sgitroutingapiqa.supergrp.net',
  ROUTING_AUTH : {
    username: 'sgxrUsr',
    password: 'SgxrUser1122333'
  }
};
